import { HTTPService } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { DialogHelper } from "../core/util/dialogHelper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { ToolBarStandardButtonType } from "../core/components/toolBar";
import React from "react";
import ReactDOM from "react-dom";

export class AuArtNuKreis extends React.Component<{openNuKreis: (item: Item) => void, gridOptions: kendo.ui.GridOptions}, { items: Item[] }>{
    constructor(props) {
        super(props)
        this.state = {
            items: []
        }
        this.init();
    }

    private init = async () => {
        const result = await HTTPService.get<Item[]>("Nukreis/GetAuArtNukreis");
        this.setState({ items: result })
    }

    private createNewNukreis = (auArt: number) => {
        return new Promise<string>(async (resolve, reject) => {
            while (true) {
                const art = await this.getName();

                if (Helper.isNullOrEmpty(art)) {
                    reject();
                    break;
                } else {
                    const exits = await HTTPService.get<boolean>("Nukreis/GenerateNewNuKreis?art=" + art + "&auArt=" + auArt);
                    if (exits) {
                        resolve(art);
                        break;
                    } else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("WebCRM.Nukreis.NotAvaialable"))
                    }
                }
            }
        });
    }

    private getName = () => {
        return new Promise<string>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
            ReactDOM.render(<NameDialog onOk={(value) => {
                remove_dialog();
                resolve(value);
            }} onCancel={() => {
                remove_dialog();
                resolve(null);
            }} />, targetElement[0]);
        })
    }

    private onClick = async (_, dataItem: Item) => {
        if (!Helper.hasValue(dataItem))
            return;
        let nuKreis = dataItem.NuKreis;
        if (Helper.isNullOrEmpty(nuKreis)) {
            try {
                nuKreis = await this.createNewNukreis(dataItem.Auart);
                const data = this.state.items;
                const index = data.findIndex(f => f.Auart == dataItem.Auart);
                data[index].NuKreis = nuKreis;
                this.setState({ items: data })
            } catch {
                return;
            }
        }
        this.props.openNuKreis({ Bezeichnung: dataItem.Bezeichnung, NuKreis: nuKreis })
    }

    render() {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.items}
                    options={this.props.gridOptions}
                    id="auArtNukreis"
                    standardButtons={[{ type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: true }]}
                    onClickStandardButton={this.onClick}
                />
            </div>
        );
    }
}

class NameDialog extends React.Component<{ onOk: (value: string) => void, onCancel: () => void }, {value: string}> {
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebCRM.Nukreis.Angeben"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCancel()
                },
                primary: false
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk(this.state.value)
                },
                primary: true
            }
        ],
        afterClose: () => {
        },
        width: 300
    };
    private factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props)
        this.state = {
            value: ""
        }
    }


    private renderTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.value;
        props.field.maxLength = 2;
        props.onChange = (_, value: string) => {
            this.setState({value: value.toUpperCase()})
        }

        return (
            <TextBox {...props}/>
        );
    }

    componentDidUpdate() {
        const el = document.querySelector(".k-dialog-content .k-textbox") as HTMLElement;
        el.focus();
    }

    render() {
        return (
            <Dialog {...this.dialogProps} open={true}>
                {this.renderTextBox()}
            </Dialog >
        );
    }
}

interface Item {
    Auart?: any,
    Bezeichnung: any,
    NuKreis: string
}